import { Button, H5 } from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { useEffect, useRef } from "react";

export const SupplierAnnouncementBanner = ({
  supplierAnnouncement,
  setHeight,
}: {
  supplierAnnouncement: Exclude<
    SupplierGetResponseType["SupplierAnnouncement"],
    null
  >;
  setHeight: (height: number | undefined) => void;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setHeight(ref.current?.clientHeight ?? 0);
  });
  return (
    <>
      <div
        ref={ref}
        className={
          "flex h-auto flex-wrap items-center justify-center gap-2 bg-zinc-600 p-2 text-center text-white md:h-[var(--nav-height)]"
        }
      >
        <H5 className={"text-white"}>{supplierAnnouncement.message}</H5>
        <div className="flex flex-row gap-2">
          {supplierAnnouncement.ctaLabel && supplierAnnouncement.ctaLink && (
            <Button
              color={"primary-dark"}
              size={"small"}
              onClick={() =>
                window.open(supplierAnnouncement.ctaLink ?? "", "_blank")
              }
            >
              {supplierAnnouncement.ctaLabel}
            </Button>
          )}
        </div>
      </div>
    </>
  );
};
